import { useEffect } from 'react';

export function useDocumentScrollable() {
  useEffect(() => {
    const root = document.documentElement;
    const update = () =>
      root.toggleAttribute('data-scrollable', root.scrollHeight > root.clientHeight);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(root);
    observer.observe(document.body);
    return () => {
      observer.disconnect();
      root.removeAttribute('data-scrollable');
    };
  }, []);
}
